declare const __HO_KUNDE__: string;

const handoutImageBaseUrl = "https://portal.stroetmann.de/bilder/output/Messeportal/digitalerhandzettel";

export const getHandoutImageUrls = (area: string, fileName: string): string[] => {
    const kundeFileName = __HO_KUNDE__
        ? fileName.endsWith("_link.png")
            ? fileName.replace("_link.png", `_${__HO_KUNDE__}_link.png`)
            : fileName.replace(".png", `_${__HO_KUNDE__}.png`)
        : fileName;

    return [
        `${handoutImageBaseUrl}/${area}/${kundeFileName}`,
        `${handoutImageBaseUrl}/${area}/${fileName}`
    ];
};